import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from '../../constants/routes';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(ROUTES.OPPORTUNITIES, {replace: true});
  }, [navigate]);

  return null;
};

export default Dashboard;
